import { useState } from "react";
import Modal from "ui-kit/src/Modal";
import { ResetModal } from "../ResetModal";
import { RetryModal } from "../RetryModal";
import { BaseTable } from "./BaseTable";
import { RowActionButton, RowActionLink, rowActionIcons } from "./rowActions";

export function VideosErroredTable() {
	const [retryModal, setRetryModal] = useState<{ id?: number, show: boolean }>({ show: false });
	const [resetModal, setResetModal] = useState<{ id?: number, show: boolean }>({ show: false });

	return (
		<>
			<BaseTable preset="errored"
				actions={{
					id: "actions",
					key: "actions",
					label: "Actions",
					header: () => "Actions",
					cell: (value, row) => (
						<div className="actionsCell">
							<RowActionLink icon={rowActionIcons.status} label="Status" to={`/video-uploads/${row.id}/status`} />
							<RowActionButton
								icon={rowActionIcons.retry}
								label="Retry"
								onClick={() => setRetryModal({ id: row.id, show: true })}
							/>
							<RowActionButton
								icon={rowActionIcons.reset}
								label="Reset"
								onClick={() => setResetModal({ id: row.id, show: true })}
							/>
						</div>
					),
				}}
			/>
			<Modal show={resetModal.show} onClose={() => setResetModal({ show: false })} size="sm" title="Reset">
				<ResetModal videoId={resetModal.id ?? 0} close={() => setResetModal({ show: false })} />
			</Modal>
			<Modal show={retryModal.show} onClose={() => setRetryModal({ show: false })} size="sm" title="Retry">
				<RetryModal videoId={retryModal.id ?? 0} close={() => setRetryModal({ show: false })} />
			</Modal>
		</>
	)

}
